export default __webpack_public_path__ + "static/tb_radler_01-7a28ed777e215a0a9e03ba2b98ff19f0.svg";